import { getVerifyUrl } from "../config/Config";
import { postRequest } from "./ServiceHelper";

export class PurlService {
  static verifyEmail = (shareCode, email, ignoreRedirect) => {
    const param = { code: shareCode, email: email };
    return postRequest(getVerifyUrl(), param, true, ignoreRedirect);
  };
}
